import { Attribution, Control } from "ol/control";

export class AttributionButton extends Control {
    constructor() {
        super({ element: undefined });
        return new Attribution({
            collapsible: false
        });
    }
}
